import ApiBase from '../ApiBase';

class Reports extends ApiBase {
    route = '/admin/reports';

    /**
     * @method getAvailableReports
     * @return {Promise<*>}
     */
    getAvailableReports = () => {
        return this.get('/admin/reports/available-reports');
    }

    /**
     * @method storeReport
     * @param {string} type
     * @param {object} params
     * @return {Promise<*>}
     */
    storeReport = (type, params) => {
        return this.post('/admin/reports', {
            type,
            params
        });
    }
}

export default new Reports;